import React from 'react';

import PropTypes from 'prop-types';

export default function StoreLocationIcon({
  color = 'currentColor',
  size = '1em',
  ...rest
}) {
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} {...rest}>
      <path
        fill={color}
        d="M7.65,28.71,18.19,5.28a5.78,5.78,0,0,1,5.27-3.41H71.32a5.78,5.78,0,0,1,5.27,3.41L87.13,28.71c3,6.66-1.39,14.55-8.69,15l-.77,0a11.19,11.19,0,0,1-10.12-6.44,11.18,11.18,0,0,1-20.17.17,11.18,11.18,0,0,1-20.17-.17A11.19,11.19,0,0,1,17.1,43.78l-.77,0C9,43.26,4.65,35.38,7.65,28.71ZM9.91,84.55h46l-.67-.91a25.21,25.21,0,0,1-4-8.38H22.93V47.75a16.11,16.11,0,0,1-5.83,1.11q-.56,0-1.12,0a15.56,15.56,0,0,1-2.34-.34V75.26H9.91a4.65,4.65,0,0,0,0,9.29Zm69,11.68a4.69,4.69,0,0,1-7.55,0L59.69,80.38C50.51,67.94,58.58,49.86,74,49.08l1.14,0,1.14,0c15.44.78,23.52,18.86,14.33,31.3Zm5.89-28a9.67,9.67,0,1,0-9.67,9.67A9.67,9.67,0,0,0,84.84,68.23Z"
      />
    </svg>
  );
}

StoreLocationIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
